import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-utilities',
  templateUrl: './utilities.component.html',
})
export class UtilitiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
